import type { TicketEventEntry } from '@easyhelp/shared';

/** Chi ha ricevuto la notifica quando il nome non è registrato (esiti precedenti a #70). */
const UNKNOWN_RECIPIENT = 'un membro del team';

/**
 * Esito di consegna di una notifica interna al team (#70): «Notifica consegnata a Luigi Bianchi.»
 * al posto di «Email consegnata da Resend.», che farebbe pensare a un'email al segnalante.
 * `null` se l'evento non è l'esito di una notifica interna.
 */
export function teamNotificationText(entry: TicketEventEntry): string | null {
  if (!entry.teamNotification) return null;
  const recipient = entry.teamNotification.recipientName ?? UNKNOWN_RECIPIENT;
  switch (entry.type) {
    case 'email_consegnata':
      return `Notifica consegnata a ${recipient}.`;
    case 'email_rimbalzata':
      // Un rimbalzo temporaneo non dice che la notifica è persa.
      return entry.teamNotification.delayed
        ? `Notifica a ${recipient} in ritardo: mancato recapito temporaneo.`
        : `Notifica non recapitata a ${recipient}.`;
    case 'email_reclamo':
      return `Notifica a ${recipient} segnalata come spam.`;
    default:
      return null;
  }
}
